import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../components/auth/AuthContext";
import { useIsAdmin } from "../hooks/useFeatureFlags";

/**
 * AdminRoute – wraps a route so it is only accessible to authenticated users
 * who hold an admin-level role: DIXI_ADMIN, Admin, or OrgAdmin.
 *
 * Unauthenticated users  → redirected to /login
 * Authenticated non-admin → redirected to /  (home)
 */
export default function AdminRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const isAdmin = useIsAdmin();
  const location = useLocation();

  if (loading) {
    return <div className="page-loading">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
